import {Spinner} from '@volkswagen-onehub/components-core';
import * as React from 'react';
import Div from '../../components/Div.styled';
import EmptyResult from '../../components/EmptyResults';
import Icon from '../../components/Icon';
import SpaceLike from '../../components/Space';
import TypographyBody from '../../components/Typography/TypographyBody';
import {convertDataForQuestionManualFour} from '../../helpers/questionManualTransformData';
import {
  OptionManualFour,
  QuestionManualContent,
  ResultQuestionFour,
  ResultQuestions,
  SelectManualProps,
} from '../../types/questionManuals';
import {config} from '../../environment';

export default function QuestionManualFour({
  handleNextStep,
  currentQuestion,
  handleSelect,
  results,
  carData,
}: {
  handleNextStep: () => void;
  currentQuestion: QuestionManualContent;
  handleSelect: (data: SelectManualProps) => void;
  results: ResultQuestions[];
  carData?: {
    rego: string;
    state: string;
  };
}) {
  const [loading, setLoading] = React.useState<boolean>(true);
  const [filteredData, setFilteredData] = React.useState<OptionManualFour[]>(
    [],
  );
  React.useEffect(() => {
    const fetchState = async () => {
      try {
        const makeQuestion = results.find((item) => item.id === 'make');
        const yearQuestion = results.find((item) => item.id === 'year');
        if (
          makeQuestion &&
          makeQuestion.makeCode &&
          yearQuestion?.year &&
          yearQuestion?.month &&
          yearQuestion?.familyCode
        ) {
          console.log(
            JSON.stringify({
              makecode: makeQuestion.makeCode,
              familycode: yearQuestion.familyCode,
              year: parseInt(yearQuestion.year),
              month: parseInt(yearQuestion.month),
            }),
          );
          const response = await fetch(`${config.API_REDBOOK_VARIENTS_URL}`, {
            method: 'POST',
            body: JSON.stringify({
              makecode: makeQuestion.makeCode,
              familycode: yearQuestion.familyCode,
              year: parseInt(yearQuestion.year),
              month: parseInt(yearQuestion.month),
            }),
            headers: {
              'Content-Type': 'application/json',
            },
            mode: 'cors',
          });

          const result: {data: ResultQuestionFour[]} = await response.json();
          const transformedData = convertDataForQuestionManualFour(result.data);

          setFilteredData(transformedData);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchState();
  }, [carData, results]);

  return (
    <SpaceLike
      direction="vertical"
      size={40}
      customStyles={{
        marginTop: 40,
        padding: '0 16px',
      }}
      className="no-scroll"
      width={'100%'}
    >
      {loading ? (
        <Div width="100%" customStyles={{textAlign: 'center'}}>
          <Spinner variant="large" />
        </Div>
      ) : filteredData?.length > 0 ? (
        filteredData?.map((item, index) => {
          return (
            <TypographyBody
              key={index}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                margin: 0,
                fontSize: 16,
                cursor: 'pointer',
              }}
              onClick={() => {
                const variant = {
                  id: currentQuestion.id || '',
                  value: item.description,
                  makeCode: item.makecode,
                  familyCode: item.familycode,
                  year: item.year,
                  month: item.month,
                  rbc: item.rbc,
                  rego: carData?.rego ?? '',
                  state: carData?.state ?? '',
                };
                handleSelect(variant);
                handleNextStep();
              }}
            >
              {item.description}
              <Icon icon="arrow-right-alt" color="white" />
            </TypographyBody>
          );
        })
      ) : (
        <EmptyResult />
      )}
    </SpaceLike>
  );
}
